// FE-SCRM-048 — Settings → Import data section. The chooser cards
// deep-link into /dashboard/sales-crm/import; the recent-imports
// table lives directly below so a producer can review past sessions
// without leaving Settings.

import { ImportChooserCards } from "./ImportChooserCards";
import { RecentImportsPanel } from "./RecentImportsPanel";


export function SettingsImportDataSection() {
  return (
    <section
      data-testid="settings-import-data"
      className="flex flex-col gap-4"
    >
      <header className="flex flex-col gap-1">
        <h2 className="text-base font-semibold text-text-primary">
          Import data
        </h2>
        <p className="text-xs text-text-secondary">
          Bulk-load your book of business from a CSV. We validate
          before anything is created.
        </p>
      </header>

      <ImportChooserCards />

      <RecentImportsPanel />
    </section>
  );
}
